import { Controller } from "@hotwired/stimulus"

// Dismissable card (e.g. the sidebar "Neuerungen" release notes card).
// Hiding persists for the current browser session via sessionStorage, so the
// card stays hidden across same-session Turbo navigations and reappears in a
// new session.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.readStoredState()) {
      this.element.classList.add("hidden")
    }
  }

  dismiss(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add("hidden")
    this.writeStoredState()
  }

  readStoredState() {
    try {
      return window.sessionStorage.getItem(this.storageKey) === "1"
    } catch {
      return false
    }
  }

  writeStoredState() {
    try {
      window.sessionStorage.setItem(this.storageKey, "1")
    } catch {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }

  get storageKey() {
    return `dismissable-card:${this.keyValue}:dismissed`
  }
}
